import EventsAthleteDashboard from "../dashboard/Events";

function AthleteEvents() {
  return (
    <div className="w-full h-full overflow-hidden">
      <div className="bg-white w-full h-full p-10">
        <EventsAthleteDashboard />
      </div>
    </div>
  );
}

export default AthleteEvents;
